import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CALENDLY_URL = 'https://calendly.com/contact-bankkimedia/30min';

const WhoItsFor = () => {
  const { t } = useTranslation();
  const w = t('home.whoItsFor', { returnObjects: true });

  return (
    <section data-testid="who-its-for" className="py-16 md:py-24 border-t border-white/5">
      <div className="container-custom max-w-3xl">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold font-['Syne'] text-white mb-3">{w.title}</h2>
          <p className="text-gray-400">{w.subtitle}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {w.audiences.map((audience, i) => (
            <motion.div key={i} initial={{ opacity: 0, x: -10 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }} className="flex items-center gap-3 py-3 px-4 rounded-lg bg-white/[0.02] border border-white/5">
              <Check className="w-4 h-4 text-[#c8ff00] flex-shrink-0" />
              <span className="text-gray-300 text-sm">{audience}</span>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-white/50 text-sm mb-4">{w.ctaText}</p>
          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
            <motion.span whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#c8ff00] text-black font-bold rounded-full hover:bg-[#d4ff33] transition-colors">
              {w.cta}
              <ArrowRight className="w-4 h-4" />
            </motion.span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;
